import { render, staticRenderFns } from "./RemoteChemicalList.vue?vue&type=template&id=3ad7933f&scoped=true&"
import script from "./RemoteChemicalList.vue?vue&type=script&lang=js&"
export * from "./RemoteChemicalList.vue?vue&type=script&lang=js&"
import style0 from "./RemoteChemicalList.vue?vue&type=style&index=0&id=3ad7933f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7933f",
  null
  
)

export default component.exports